import { render, staticRenderFns } from "./ReportSummary.vue?vue&type=template&id=ffd0f098&scoped=true"
import script from "./ReportSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ReportSummary.vue?vue&type=style&index=0&id=ffd0f098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd0f098",
  null
  
)

export default component.exports